import {
  Counterparty,
  InstallerPersonOrUnassignedOrInstallersGroup,
  Product,
  QualityControlStatus,
  RequestStatus,
} from '@core/types';
import { TuiDay, TuiDayRange, TuiTime } from '@taiga-ui/cdk';
import type { LogisticRequestType } from '@outkeep/shared';

export interface FilterObject {
  requestType?: LogisticRequestType[];
  products?: Product[];
  requestStatus?: RequestStatus;
  qualityControlStatus?: QualityControlStatus;
  installers?: InstallerPersonOrUnassignedOrInstallersGroup[];
  requestNumber?: string;
  projectNumber?: string;
  // одиночный id или массив id; null в массиве = «Без исполнителя»
  contractorCounterpartyId?: number | (number | null)[];
  contractorCounterpartySubdivisionId?: number;
  counterpartyOwner?: Counterparty;
  contract?: string;
  carModelAndBrand?: string;
  carPlantNumber?: string;
  vin?: string;
  subjName?: string;
  deliveryAddress?: string;
  deliveryName?: string;
  releaseDatePeriod?: TuiDayRange | null;
  releaseDate?: TuiDay | null;
  releaseTime?: TuiTime | null;
  createdViaApi?: boolean;
  inventoryDocUploaded?: boolean;
  leasingProduct?: string;
  extendedProgram?: string;
  manufacturerCompany?: string;
  manufacturerCountry?: string;
  isForCreateRequests?: boolean;
  obdStatus?: number;
}

export interface FilterQuery {
  assignedToMe?: boolean;
  statusId?: number | Record<string, number>;
  qualityControlStatus?: number;
  requestType?: LogisticRequestType | LogisticRequestType[];
  productsIds?: Product['id'][];
  installerId?: number[];
  requestNumber?: string;
  projectNumber?: string;
  // одиночный id или массив id; null в массиве = «Без исполнителя»
  contractorCounterpartyId?: number | (number | null)[];
  contractorCounterpartySubdivisionId?: number;
  counterpartyOwnerId?: number;
  contract?: string;
  carModelAndBrand?: string;
  carPlantNumber?: string;
  vin?: string;
  subjName?: string;
  deliveryAddress?: string;
  deliveryName?: string;
  releaseDatePeriod?: {
    startDate: string;
    endDate: string;
  };
  releaseDate?: string;
  releaseTime?: string;
  createdViaApi?: boolean;
  inventoryDocUploaded?: boolean;
  leasingProduct?: string;
  extendedProgram?: string;
  manufacturerCompany?: string;
  manufacturerCountry?: string;
  isForCreateRequests?: boolean;
  obdStatus?: number;
  installerGroup?: string;
}

export interface ActiveFilterChip {
  title: keyof FilterQuery | 'installerGroup';
  value: unknown;
  removable: boolean;
  pinnedToEnd?: boolean;
}

export enum FilterType {
  requestType = 'requestType', // Тип заявки
  products = 'products', // Товары\услуги
  requestStatus = 'requestStatus', // Статус заявки
  qualityControlStatus = 'qualityControlStatus', // Статус ОКК
  installers = 'installers', // Установщики
  requestNumber = 'requestNumber', // Номер заявки
  contract = 'contract', // Номер договора
  carModelAndBrand = 'carModelAndBrand', // Марка / VIN / Заводской
  carPlantNumber = 'carPlantNumber', // Госномер
  vin = 'vin', //VIN
  subjName = 'subjName', // Лизингополучатель
  deliveryAddress = 'deliveryAddress', // Адрес выдачи
  deliveryName = 'deliveryName', // Адрес поставщика
  releaseDatePeriod = 'releaseDatePeriod', // Дата (период)
  releaseTime = 'releaseTime', // Время
  releaseDate = 'releaseDate', // Дата
  projectNumber = 'projectNumber', // Номер проекта
  contractorCounterpartyId = 'contractorCounterpartyId', // исполнитель
  counterpartyOwnerId = 'counterpartyOwnerId', // Контрагент (заказчик)
  createdViaApi = 'createdViaApi', // Создано через API
  inventoryDocUploaded = 'inventoryDocUploaded', // Опись подгружена
  leasingProduct = 'leasingProduct', // Лизинговый продукт
  extendedProgram = 'extendedProgram', // Расширенная программа
  manufacturerCompany = 'manufacturerCompany', // Изготовитель (компания)
  manufacturerCountry = 'manufacturerCountry', // Изготовитель (страна)
  isForCreateRequests = 'isForCreateRequests', // Заявка - Запрос на создание заявок
  obdStatus = 'obdStatus', // Статус OBD
}

export enum GroupActionsViews {
  Main = 'main',
  SelectedRequests = 'selectedRequests',
  ConfirmActualDeliveryAddress = 'confirmActualDeliveryAddress',
  AddDealDetails = 'addDealDetails',
  ChangeStatus = 'changeStatus',
  InternalRatings = 'internalRatings',
  InstallerAssignment = 'installerAssignment',
  UploadFiles = 'uploadFiles',
  ChangeReleaseDate = 'changeReleaseDate',
}
